import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import PackagingContent from './components/PackagingContent';

export default function PackagingPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '包裝設計｜保健食品包材・標示合規・設計流程｜康永生技',
    description: '康永生技包裝設計服務：盒型、瓶罐、鋁箔袋、PTP 包裝多元材質選擇，6步驟設計流程，10項必須標示項目審查，確保包裝合法合規。',
    keywords: '包裝設計,保健食品包裝,包材選擇,標示合規,包裝流程,盒型,鋁箔袋,PTP',
    lang: 'zh-TW',
    canonicalPath: '/services/packaging',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="包裝設計｜保健食品包材・標示合規・設計流程｜康永生技" pageDescription="康永生技包裝設計服務：盒型、瓶罐、鋁箔袋、PTP 包裝多元材質選擇，6步驟設計流程，10項必須標示項目審查，確保包裝合法合規。" pageUrl={`${siteUrl}/services/packaging`} />
      <PackagingContent />
    </Layout>
  );
}